<div *ngIf="companyDetails" class="container mt-4">
  <div class="row">
    <div class="col-md-6">
      <!-- <h1>{{ companyDetails.companyName }}</h1> -->
      <p><strong>Company Name:</strong> {{ companyDetails.companyName }}</p>
      <p><strong>Address:</strong> {{ companyDetails.address }}</p>
      <p><strong>Region:</strong> {{ companyDetails.region }}</p>
    </div>
  </div>
</div>

<div *ngIf="memberDetails" class="container mt-4">
  <h1>
    <strong>
      Member Details
    </strong>
  </h1>
  <div class="row">
    <div class="col-md-6">
      <p><strong>Name:</strong> {{ memberDetails.memberName }}</p>
      <p><strong>Email:</strong> {{ memberDetails.email }}</p>
    </div>
    <div class="col-md-6">
      <p><strong>Mobile:</strong> {{ memberDetails.mobile }}</p>
      <p><strong>WhatsApp:</strong> {{ memberDetails.isWhatsApp ? 'Yes' : 'No' }}</p>
    </div>
    <div class="col-md-6">
      <p><strong>Skype ID:</strong> {{ memberDetails.skypeId }}</p>
      <p><strong>Telephone:</strong> {{ memberDetails.telephone }}</p>
    </div>
  </div>
</div>
